import { graphql } from 'src/graphql';

import { BookingSegmentsFields } from 'containers/Studies/data/fragments/BookingSegments.fragment';

import type { VariablesOf } from 'src/graphql';

export const UpdateBookingConfig = graphql(
  `
    mutation UpdateBookingConfig($_id: ID!, $input: UpdateBookingConfigInput!) {
      updateBookingConfig(_id: $_id, input: $input) {
        _id
        recruit {
          participants
          device
          supports_conditional_screener
          estimated_duration
          locations {
            type
            location {
              name
              city
              state
              country
              latitude
              longitude
              level
              timezone
              postal_code
              formatted_address
              google_location_types
              region
              street1
              google_location {
                place_id
                name
                address_components {
                  long_name
                  short_name
                  types
                }
                geometry {
                  latitude_ne
                  longitude_ne
                  latitude_sw
                  longitude_sw
                  width
                  height
                  radius_min
                  radius_max
                }
                viewport {
                  northeast {
                    lat
                    lng
                  }
                  southwest {
                    lat
                    lng
                  }
                }
                map_polygon_id
              }
              currency_code
              currency_symbol
            }
          }
          age_range
          gender
          industry_and_occupation {
            _id
            name
            subcategories {
              _id
              name
            }
          }
          languages {
            locale
            fluency
          }
          education_level
          marital_status
          occupational_status
          business_ownership
          screener_questions {
            _id
            type
            title
            description
            is_multiple_selection
            options {
              _id
              label
              is_qualified
              verdict
            }
            conditional_logic {
              rules {
                _id
                match
                option_ids
                target {
                  action
                  question_id
                }
              }
              fallback {
                action
                question_id
              }
            }
          }
          participant_selection
          participants_excluded_months
          participants_excluded_from_studies
          participant_source
          byo_additional_fields
          byo_block_vpn
          byo_unique_device
          byo_privacy_policy_url
          additional_participant_instructions {
            enabled
            content
          }
          custom_terms {
            recipients
            _template_id
          }
        }
        contact {
          _primary_contact_id
        }
        listing_information {
          title
          description
        }
        config {
          participant_agreement {
            type
            _template_id
            recipients
            ESignatureTemplate {
              _id
              name
              provider {
                reference
              }
            }
          }
        }
        booking_segments {
          ...BookingSegmentsFields
        }
      }
    }
  `,
  [BookingSegmentsFields],
);

export type UpdateBookingConfigInput = VariablesOf<typeof UpdateBookingConfig>['input'];
